import { Box, type BoxProps, type SxProps, type Theme } from "@mui/material";
import { DATA_GRID_SURFACE_SX } from "@/constants/layout";

export function DataGridSurface({ children, sx, ...rest }: BoxProps) {
  return (
    <Box
      sx={
        sx
          ? ([DATA_GRID_SURFACE_SX, sx] as SxProps<Theme>)
          : DATA_GRID_SURFACE_SX
      }
      {...rest}
    >
      {children}
    </Box>
  );
}
